"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputText = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../../styles/palette");

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InputText = function (_PureComponent) {
  (0, _inherits2["default"])(InputText, _PureComponent);

  var _super = _createSuper(InputText);

  function InputText(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, InputText);
    _this = _super.call(this, props);

    _this.onChange = function (e) {
      var handleChange = _this.props.handleChange;

      _this.setState({
        dirty: e.target.value !== '',
        value: e.target.value
      });

      if (handleChange) handleChange(e.target.value);
    };

    _this.onFocus = function () {
      var handleFocus = _this.props.handleFocus;

      _this.setState({
        active: true
      });

      if (handleFocus) handleFocus();
    };

    _this.onBlur = function () {
      var handleBlur = _this.props.handleBlur;
      var value = _this.state.value;

      _this.setState({
        active: false
      });

      if (handleBlur) handleBlur(typeof value === 'string' ? value.trim() : undefined);
    };

    _this.state = {
      active: false,
      dirty: !!props.value || false,
      value: props.value || ''
    };
    return _this;
  }

  (0, _createClass2["default"])(InputText, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;

      if (value !== prevProps.value) {
        this.setState({
          dirty: value !== '',
          value: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          active = _this$state.active,
          dirty = _this$state.dirty,
          value = _this$state.value;
      var _this$props = this.props,
          error = _this$props.error,
          errorHelper = _this$props.errorHelper,
          forwardRef = _this$props.forwardRef,
          helper = _this$props.helper,
          icon = _this$props.icon,
          id = _this$props.id,
          label = _this$props.label,
          width = _this$props.width;
      return _react["default"].createElement(_style.InputContainer, {
        dirty: dirty,
        "data-active": active,
        error: error,
        icon: icon,
        width: width
      }, _react["default"].createElement("label", {
        htmlFor: id
      }, label), icon && _react["default"].createElement(_style.StyledIcon, {
        color: error ? _palette.palette.error : active ? _palette.palette.link : _palette.palette.bobBlack,
        icon: icon,
        size: 24
      }), _react["default"].createElement("input", {
        id: id,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        ref: forwardRef,
        type: "text",
        value: value
      }), error ? _react["default"].createElement(_style.Error, null, errorHelper) : _react["default"].createElement("span", null, helper));
    }
  }]);
  return InputText;
}(_react.PureComponent);

exports.InputText = InputText;
InputText.propTypes = {
  error: _propTypes["default"].bool,
  errorHelper: _propTypes["default"].string,
  forwardRef: _propTypes["default"].shape({}),
  handleBlur: _propTypes["default"].func,
  handleChange: _propTypes["default"].func,
  handleFocus: _propTypes["default"].func,
  helper: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
InputText.defaultProps = {
  error: false,
  errorHelper: null,
  forwardRef: null,
  handleBlur: null,
  handleChange: null,
  handleFocus: null,
  helper: null,
  icon: null,
  value: null,
  width: null
};
var _default = InputText;
exports["default"] = _default;